


















import { Mixins, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import ViewImage from 'components/presenter/item/topic/viewer/Image.vue'
import FileInput from 'components/presenter/item/FileInput.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    ViewImage,
    FileInput
  }
})
export default class ItemTopicSlidesEditorFormImage extends Mixins(MixinForm) {
  onInputMeta: Json = {}

  @Prop()
  readonly slides!: Json[]

  setSrc (src: string) {
    if (src !== this.slide.src) {
      this.onInputMeta.src = src
      this.onInputMeta.meta = this.slide.meta || this.onInputMeta.meta
      this.setOption('src', src)
      this.setOption('meta', null)
    }
  }

  updateMetaPDF (numPages: number) {
    if (this.onInputMeta.src === this.slide.src) {
      const metaPages = (this.onInputMeta.meta?.pages || [] as Json[])
      const existingPages = this.updateMetaPDFRemoveNonExistingPages(numPages, metaPages)
      const sortStart = existingPages[ existingPages.length - 1 ]?.sort || this.slide.sort
      const sortEnd = this.slides[ this.slides.indexOf(this.slide) + 1 ]?.sort || this.slide.sort + 1 + Math.abs(numPages - existingPages.length)
      const sortDelta = (sortEnd - sortStart) / (Math.abs(numPages - existingPages.length) + 1)
      const pages = this.udpateMetaPDFAddMissingPages(numPages, existingPages, this.slide.sort, sortDelta)
      this.setOption('meta', { pages })
    }
    this.onInputMeta = {}
  }

  updateMetaPDFRemoveNonExistingPages (numPages: number, pages: Json[]) {
    return pages.filter(item => +item.pageNo > 0 && +item.pageNo <= numPages)
  }

  udpateMetaPDFAddMissingPages (numPages: number, existingPages: Json[], sort: number, sortDelta: number) {
    const pages = [...existingPages]
    for (let pageNo = 1 ; pageNo <= numPages ; pageNo++) {
      if (!existingPages.some(item => item.pageNo === pageNo)) {
        sort += sortDelta
        pages.push({ pageNo, sort })
      }
    }
    return pages
  }
}
